import { Modal, message } from 'ant-design-vue'

export const OPEN_REPORT_ERR_DRAWER_2BUS_KEY = 'openReportErrorDrawer2bus'

export const REPORT_ERROR_FROM_DICT = {
  msgErr: 'message.error',
  modalErr: 'modal.error'
}

const _modalError = Modal.error
Object.assign(Modal, {
  error(props = {}) {
    const customProps =
      !global_env.isMerchant || props?.okText || props?.cancelText || props.original
        ? {}
        : {
            okCancel: true,
            okText: 'Report Error',
            okType: 'default',
            cancelText: 'I get it',
            autoFocusButton: null,
            onOk() {
              klook.bus.$emit(OPEN_REPORT_ERR_DRAWER_2BUS_KEY, {
                message: props.content || '',
                from: REPORT_ERROR_FROM_DICT.modalErr
              })
            }
          }

    return _modalError({
      ...customProps,
      ...props
    })
  }
})

const _messageError = message.error
Object.assign(message, {
  error(props = {}) {
    if (!global_env.isMerchant || typeof props?.content === 'function' || props?.original) {
      return _messageError(props)
    }

    const content = 'string' === typeof props ? props : props.content || ''

    return _messageError({
      ...props,
      content(h) {
        return h('label', { style: { display: 'inline-flex', alignItems: 'center' } }, [
          h('span', {
            domProps: {
              innerHTML: content
            }
          }),
          h(
            'button',
            {
              class: 'ant-btn ant-btn-sm',
              style: { marginLeft: '24px' },
              on: {
                click() {
                  klook.bus.$emit(OPEN_REPORT_ERR_DRAWER_2BUS_KEY, {
                    message: content,
                    from: REPORT_ERROR_FROM_DICT.msgErr
                  })
                }
              }
            },
            [h('span', 'Report error')]
          )
        ])
      }
    })
  }
})

export { Modal, message }
